import React from 'react';
import { Header } from '../header';
import CallToActionFooter from '../footer';



const Layout = ({ children }) => {
  return (
    <>
 
      <main className="  ">
        {children}
      </main>
      <CallToActionFooter />
    </>
  );
};

export default Layout;
